module.exports={
	"Form": "DocumentApprovalStateViewManifest",
	"Scope": "DocumentApprovalState-View",
	"Descriptors":
	{
		"DocumentApprovalStateDetails.IDDocumentApprovalState":
		{
			"Name": "ID",
			"Hash": "DocStateView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "DocStateIdentity",
				"Group": "DocStateIdentity"
			}
		},
		"DocumentApprovalStateDetails.GUIDDocumentApprovalState":
		{
			"Name": "GUID",
			"Hash": "DocStateView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "DocStateIdentity",
				"Group": "DocStateIdentity"
			}
		},
		"DocumentApprovalStateDetails.Name":
		{
			"Name": "State Name",
			"Hash": "DocStateView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 3,
				"Section": "DocStateIdentity",
				"Group": "DocStateIdentity"
			}
		},
		"DocumentApprovalStateDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "DocStateView-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 3,
				"Section": "DocStateIdentity",
				"Group": "DocStateIdentity"
			}
		},
		"DocumentApprovalStateDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "DocStateView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "DocStateAudit",
				"Group": "DocStateAudit"
			}
		},
		"DocumentApprovalStateDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "DocStateView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "DocStateAudit",
				"Group": "DocStateAudit"
			}
		},
		"DocumentApprovalStateDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "DocStateView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "DocStateAudit",
				"Group": "DocStateAudit"
			}
		},
		"DocumentApprovalStateDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "DocStateView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "DocStateAudit",
				"Group": "DocStateAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "DocStateIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "DocStateIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "DocStateAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "DocStateAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
